<template>
  <div class="container mt-5">
    <div class="text-center cancel-page">
      <div class="cancel-icon-container mb-4">
        <i class="mdi mdi-close-circle cancel-icon"></i>
      </div>
      
      <h1 class="cancel-title mb-3">Payment Cancelled</h1>
      
      <div class="cancel-message mb-4">
        <p class="lead">
          No worries! Your payment was cancelled and you haven't been charged.
        </p>
        <p>
          You can upgrade to premium anytime to unlock advanced hunting tools and exclusive features.
        </p>
      </div>

      <div class="premium-reminder mb-4">
        <h5 class="mb-3">Premium Features You're Missing:</h5>
        <div class="row">
          <div class="col-md-6">
            <div class="feature-item">
              <i class="mdi mdi-map-marker-plus text-muted"></i>
              <span>Advanced hunt planning tools</span>
            </div>
            <div class="feature-item">
              <i class="mdi mdi-headset text-muted"></i>
              <span>Priority customer support</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="feature-item">
              <i class="mdi mdi-chart-line text-muted"></i>
              <span>Exclusive hunting insights</span>
            </div>
            <div class="feature-item">
              <i class="mdi mdi-map text-muted"></i>
              <span>Advanced mapping features</span>
            </div>
          </div>
        </div>
      </div>

      <div class="pricing-reminder mb-4">
        <div class="price-card">
          <div class="price-display">
            <span class="price-amount">$20</span>
            <span class="price-period">/year</span>
          </div>
          <p class="text-muted">Cancel anytime</p>
        </div>
      </div>

      <div class="action-buttons">
        <button @click="tryAgain" class="btn btn-primary btn-lg me-3">
          <i class="mdi mdi-crown me-2"></i>
          Try Premium Again
        </button>
        <button @click="goToHome" class="btn btn-outline-secondary btn-lg">
          <i class="mdi mdi-home me-2"></i>
          Continue with Free
        </button>
      </div>

      <div class="help-info mt-4">
        <p class="text-muted">
          <i class="mdi mdi-help-circle me-2"></i>
          Need help? <a href="/contact" class="text-primary">Contact our support team</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PremiumCancel',
  data() {
    return {
      showUpgradeModal: false,
    };
  },
  methods: {
    tryAgain() {
      this.showUpgradeModal = true;
    },
    goToHome() {
      this.$router.push('/');
    },
    closeUpgradeModal() {
      this.showUpgradeModal = false;
    },
    handleUpgradeSuccess() {
      this.showUpgradeModal = false;
      this.$router.push('/premium-success');
    },
  },
};
</script>

<style scoped>
.cancel-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.cancel-icon-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.cancel-icon {
  font-size: 5rem;
  color: #6c757d;
  animation: cancelPulse 2s ease-in-out;
}

@keyframes cancelPulse {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.cancel-title {
  color: #6c757d;
  font-weight: 600;
  font-size: 2.5rem;
}

.cancel-message {
  color: #6c757d;
  max-width: 600px;
  margin: 0 auto;
}

.premium-reminder {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  padding: 2rem;
  margin: 2rem 0;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 1rem;
  opacity: 0.7;
}

.feature-item i {
  margin-right: 0.75rem;
  font-size: 1.25rem;
  width: 24px;
}

.pricing-reminder {
  text-align: center;
}

.price-card {
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.5rem 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.price-display {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.price-amount {
  font-size: 2.5rem;
  color: #ffd700;
}

.price-period {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin-left: 0.25rem;
}

.action-buttons {
  margin: 2rem 0;
}

.help-info {
  border-top: 1px solid #e9ecef;
  padding-top: 1rem;
}

.help-info a {
  text-decoration: none;
}

.help-info a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .cancel-page {
    padding: 1.5rem;
  }
  
  .cancel-title {
    font-size: 2rem;
  }
  
  .cancel-icon {
    font-size: 4rem;
  }
  
  .action-buttons .btn {
    display: block;
    width: 100%;
    margin-bottom: 1rem;
  }
  
  .action-buttons .btn:last-child {
    margin-bottom: 0;
  }
  
  .price-display {
    font-size: 1.5rem;
  }
  
  .price-amount {
    font-size: 2rem;
  }
}
</style>
